import { ERROR_TITLES } from '@apiary/shared'
import { ApiError, NetworkError } from '@/lib/api-error'

/**
 * Ошибка запроса → текст для нового слоя.
 *
 * `lib/problem-message.ts` использовать нельзя: он принимает `TFunction`, а
 * здесь i18n нет по решению проекта. Дублирования каталога при этом не возникает —
 * `ERROR_TITLES` в `@apiary/shared` уже русские, и это тот же самый источник,
 * которым пользуется сервер, когда собирает `problem+json`.
 *
 * Приоритет у серверного `detail`: он конкретнее шаблона по коду
 * («Аккаунт «main» занят ботом anchor-1» против «MC-аккаунт уже используется»).
 */
export function problemText(error: unknown): string {
  if (error instanceof ApiError) {
    const detail = error.problem.detail
    if (detail !== undefined && detail.trim() !== '') return detail
    return ERROR_TITLES[error.code]
  }
  // Ответа не было вообще: сеть, CORS, упавший upstream.
  if (error instanceof NetworkError) return 'Сервер не ответил. Проверьте связь и повторите.'
  return error instanceof Error ? error.message : String(error)
}

/**
 * Поля из `VALIDATION_FAILED` → `{ путь: сообщение }`.
 *
 * Нужно, чтобы серверная валидация подсвечивала ТО ЖЕ поле, что и клиентская:
 * иначе «пароль короче 12 символов» приезжает общим баннером наверху формы, и
 * пользователь ищет, что именно исправлять.
 */
export function fieldErrorsOf(error: unknown): Record<string, string> {
  if (!(error instanceof ApiError)) return {}
  const found: Record<string, string> = {}
  for (const item of error.fieldErrors) found[item.path] = item.message
  return found
}
